<mat-toolbar color="primary" style="position:sticky; top:0; z-index: 999">
  <span style="display: flex; flex-grow: 1;">Ngx-Morse</span>
</mat-toolbar>

<div class="container"> 

  <br><br>

  <div class="align-center">
    A simple morse code encoder and decoder library for Angular.
  </div>

  <br><br>

  <div class="align-center">
    <mat-radio-group
      [(ngModel)]="mode"
      (change)="reset()">
      <mat-radio-button [value]="'ENCODER'" class="mx-4">
        Encoder
      </mat-radio-button>
      <mat-radio-button [value]="'DECODER'" class="mx-4">
        Decoder
      </mat-radio-button>
    </mat-radio-group>
  </div>

  <br>

  <div *ngIf="mode=='ENCODER'">
    <mat-form-field appearance="outline" class="w-100">
      <mat-label>Enter text input!</mat-label>
      <textarea matInput [(ngModel)]="encodeInput" rows="4" (keyup)="encode()"></textarea>
    </mat-form-field>

    <br>

    <mat-form-field appearance="outline" class="w-100">
      <mat-label>Output</mat-label>
      <textarea matInput [(ngModel)]="encodeOutput" rows="4" readonly></textarea>
    </mat-form-field>
  </div>

  <div *ngIf="mode=='DECODER'">
    <mat-form-field appearance="outline" class="w-100">
      <mat-label>Enter code input!</mat-label>
      <textarea matInput [(ngModel)]="decodeInput" rows="4" (keyup)="decode()"></textarea>
    </mat-form-field>

    <br>

    <mat-form-field appearance="outline" class="w-100">
      <mat-label>Output</mat-label>
      <textarea matInput [(ngModel)]="decodeOutput" rows="4" readonly></textarea>
    </mat-form-field>
  </div>

  <h4>Installation</h4>

  <pre class="code">{{code.installation}}</pre>

  <h4>Usage</h4>

  <pre class="code">{{code.usage}}</pre>

  <br>

  <div class="align-center">
    <a matTooltip="Github" target="_blank" href="https://github.com/monkeyscript/ngx-morse">
      <i class="fa fa-github fa-lg"></i>
    </a>
  </div>

  <br><br>

</div>